import { atom } from 'jotai';

import { ActionTypeName } from '@/src/modules/CampaignsModule/interfaces/Campaigns';
import { IRestricted } from '@/src/presentation/types/types';

export const atomActionTypeName = atom<ActionTypeName>('email');
atomActionTypeName.debugLabel = 'atomActionTypeName';

export const atomRestrictions = atom<IRestricted | null>(null);
atomRestrictions.debugLabel = 'atomRestrictions';
